import SendCode from './send-code';

export default SendCode;
